import NavSearch from './NavSearch';

export default NavSearch;
